var basex = require('base-x')
var ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'

module.exports = basex(ALPHABET)



//////////////////
// WEBPACK FOOTER
// ./node_modules/bs58/index.js
// module id = 267
// module chunks = 0